import { render, staticRenderFns } from "./MarunageTable.vue?vue&type=template&id=1d79ffbc&"
import script from "./MarunageTable.vue?vue&type=script&lang=js&"
export * from "./MarunageTable.vue?vue&type=script&lang=js&"
import style0 from "./MarunageTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports